var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimecourses(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 80,
    viewBox: "0 0 56 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M16 80C38.1 80 56 62.1 56 40L16 40L16 80Z",
    fill: "#B0BEC5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M56 40C56 17.9 38.1 6.66337e-06 16 7.62939e-06L16 40L56 40Z",
    fill: "#B0BEC5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 26.6875C13.5833 26.6875 11.3542 27.2917 9.3125 28.5C7.27083 29.6667 5.64583 31.2708 4.4375 33.3125C3.27083 35.3542 2.6875 37.5833 2.6875 40C2.6875 41.75 3.02083 43.4583 3.6875 45.125C4.35417 46.75 5.3125 48.1875 6.5625 49.4375C7.8125 50.6875 9.25 51.6458 10.875 52.3125C12.5417 52.9792 14.25 53.3125 16 53.3125C18.9583 53.3125 21.625 52.4375 24 50.6875V47.0625C23 48.1875 21.7917 49.0833 20.375 49.75C19 50.375 17.5417 50.6875 16 50.6875C14.0833 50.6875 12.2917 50.2083 10.625 49.25C9 48.2917 7.70833 47 6.75 45.375C5.79167 43.7083 5.3125 41.9167 5.3125 40C5.3125 38.0833 5.79167 36.3125 6.75 34.6875C7.70833 33.0208 9 31.7083 10.625 30.75C12.2917 29.7917 14.0833 29.3125 16 29.3125C18.2083 29.3125 20.2083 29.9375 22 31.1875C23.7917 32.3958 25.0833 34 25.875 36H28.75C27.875 33.25 26.2708 31.0208 23.9375 29.3125C21.6042 27.5625 18.9583 26.6875 16 26.6875ZM14.6875 33.3125V41.3125L21.6875 45.5625L22.6875 43.875L16.6875 40.3125V33.3125H14.6875ZM26.6875 38.6875V48H29.3125V38.6875H26.6875ZM26.6875 50.6875V53.3125H29.3125V50.6875H26.6875Z",
    fill: "#FF4081"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimecourses);
export default __webpack_public_path__ + "static/media/timecourses.1408be18629fbe100b644b0626c4bab6.svg";
export { ForwardRef as ReactComponent };